import { Select, MenuItem } from "@mui/material";

function SelectStatus({ status,code, onChangeStatus,disabled }) {
  return (
    <Select
      value={status}
      onChange={(e) => onChangeStatus(code, e.target.value)}
      displayEmpty
      size="small"
      disabled={disabled}
      sx={{
        minWidth: 120,
        fontSize: "0.875rem",
        '& .MuiSelect-select': {
          paddingY: 0.5,
          paddingX: 1,
        }
      }}
    >
      <MenuItem value="PENDING">
        Pending
      </MenuItem>
      <MenuItem value="IN_PROGRESS">
        In progress
      </MenuItem>
      <MenuItem value="COMPLETED">
        Completed
      </MenuItem>
      <MenuItem value="CANCELLED">
        Cancelled
      </MenuItem>
    </Select>
  );
}

export default SelectStatus;
